import { Grid, styled } from '@mui/material';
import { PDFFooter } from '../PDFFooter/PDFFooter';
import { PDFHeader } from '../PDFHeader/PDFHeader';
import { ProjectedWealthPathChart, ProjectedWealthPathChartProps } from '.';
import { PDFTitle, PDFTitleProps } from '../../organisms/PDF/PDFTitle';
import { useTranslation } from 'react-i18next';
import { Typography } from '../../atoms/Typography/Typography';

export const StyledDisclaimerContent = styled(Typography)(({ theme }) => ({
    fontWeight: 400,
    fontSize: theme.spacing(1.5),
    margin: `${theme.spacing(3)} 0`,
    lineHeight: theme.spacing(2),
    color: theme.palette.grey[400]
}));

export type PDFProjectedWealthPathChartProps = ProjectedWealthPathChartProps &
    PDFTitleProps & {
        totalPages?: number;
        currentPages?: number;
        retirementYear?: number;
        disclaimer?: string;
    };
export const PDFProjectedWealthPathChart = ({
    totalPages,
    currentPages,
    // bankruptcyYear,
    data,
    plotLine,
    lowPercentile,
    highPercentile,
    targetPercentile,
    goalPriority,
    goalName,
    goalType,
    priority,
    type,
    retirementYear,
    disclaimer,
    goalPriorityProbability,
    goalTargetDate,
    targetGoalAmount,
    projectedGoalAmount,
    goalProbabilityPercentile,
    isRetirement,
    isRecomendation
}: PDFProjectedWealthPathChartProps) => {
    const { t } = useTranslation();
    return (
        <Grid height={'1000px'} position={'relative'} marginBottom={'40px'}>
            <PDFHeader pageName={t('PROJECTED_WEALTH_PATH_TITLE')} />
            <PDFTitle goalName={goalName} goalType={goalType} priority={priority} type={type} />
            <ProjectedWealthPathChart
                isReadOnly
                data={data}
                // bankruptcyYear={bankruptcyYear}
                plotLine={plotLine}
                lowPercentile={lowPercentile}
                highPercentile={highPercentile}
                targetPercentile={targetPercentile}
                goalPriority={goalPriority}
                retirementYear={retirementYear}
                goalPriorityProbability={goalPriorityProbability}
                goalTargetDate={goalTargetDate}
                targetGoalAmount={targetGoalAmount}
                projectedGoalAmount={projectedGoalAmount}
                goalProbabilityPercentile={goalProbabilityPercentile}
                isRetirement={isRetirement}
                isRecomendation={isRecomendation}
            />
            {disclaimer && <StyledDisclaimerContent marginTop={'-50px'} label={disclaimer} />}
            <PDFFooter totalPages={totalPages ?? 1} currentPage={currentPages ?? 1} />
        </Grid>
    );
};
